module.exports = __webpack_public_path__ + "01_mole.bb206ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/01_mole.png
// module id = vLAD
// module chunks = 0